import { globalGetService, globalPostService, globalPutService ,globalDeleteService} from '../../../utils_v2/globalApiServices';
import { checkApiStatus } from '../../../utils_v2';
import { toastFlashMessage } from '../../../utils';
export function getRelatedLoanListApi(props={}, query={}){
  globalGetService(`contracts/${props.params.contract_slug}/related-loan/`, query)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({
        list: response.data.data
      })
    }
    this.setState({skeletonLoader:false});
  })
}
export function getRelatedLoanApi(props={}, id, mode){
  this.setState({pageLoader:true});
  globalGetService(`contracts/${props.params.contract_slug}/related-loan/${id}`)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({ error:{}, relatedLoan:response.data.data, modal:true, mode: mode === 'V' ? 'view':'edit'})
    }
    this.setState({pageLoader:false});
  })
}
export function addRelatedLoanApi(props={}, data={}){
  return new Promise(
    function(resolve, reject){
      if(data.id){
        globalPutService(`contracts/${props.params.contract_slug}/related-loan/${data.id}/`, data)
        .then(response => {
          resolve(response);
        })
      }else{
        globalPostService(`contracts/${props.params.contract_slug}/related-loan/`, data)
        .then(response => {
          resolve(response);
        })
      }
    }
  )
}

export function deleteRelatedLoanApi(props,deleteItem) {
  this.setState({pageLoader:true});
  globalDeleteService(`contracts/${props.params.contract_slug}/related-loan/${deleteItem.data.id}/`)
    .then(response => {
      if (checkApiStatus(response)) {
        this.setState(prevState => ({
          ...prevState,
          list: prevState.list.filter((item, index) => item.id != deleteItem.data.id),
          deleteItem:{modal:false, data:null}
        }))
        toastFlashMessage(response?.data?.message, 'success')
      } else {
        toastFlashMessage(response?.data?.message, 'error')
      }
      this.setState({pageLoader:false});
    })
}
